export const GOAL_NAME = 'goalName';
export const GOAL_STATUS = 'goalStatus';
